// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import SearchControler from "../SearchControler/SearchControler";
import Translate from "react-translate-component";
// import {Button} from "react-bootstrap";
// import {Tabs, Tab} from "react-bootstrap";
// import SearchForm from "../SearchForm/SearchForm";

import "./SearchContainer.css";
class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeData: "",
      industryData: "",
      displaySearchTabs: false,
    };
  }

  render() {
    console.log(this.props);
    return (
      <div className="searchContainer">
        <Translate
          content="searchControl.title"
          component="h2"
          className="main-head"
        />
        <Translate content="searchControl.desc" component="p" unsafe={true} />
        <SearchControler />
      </div>
    );
  }
}

export default Search;
